export const FooterdataEN = {
  "jcr:primaryType": "cq:PageContent",
  "jcr:createdBy": "admin",
  "title": "footer-page",
  "cq:template": "/apps/gdocs/templates/page-create-case",
  "jcr:language": "en",
  "cq:contextHubSegmentsPath": "/etc/segmentation/contexthub",
  "jcr:created": "Thu Feb 07 2019 06:30:52 GMT+0000",
  "cq:lastModified": "Wed Oct 25 2017 14:28:20 GMT+0000",
  "cq:cloudserviceconfigs": [
    "[]"
  ],
  "sling:resourceType": "gdocs/components/pages/create-case",
  "cq:contextHubPath": "/etc/cloudsettings/default/contexthub",
  "cq:lastModifiedBy": "admin",
  "par": {
    "jcr:primaryType": "nt:unstructured",
    "sling:resourceType": "wcm/foundation/components/parsys",
    "static_text_darkTitleBar": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "label":"Opens in new window",
      "privacy": "Privacy notice",
      "cookies": "Cookie notice",
      "termsCondition": "Terms & Conditions",
      "sling:resourceType": "gdocs/components/content/static_text"
    }
  }
}

export const FooterdataES = {
  "jcr:primaryType": "cq:PageContent",
  "jcr:createdBy": "admin",
  "title": "footer-page",
  "cq:template": "/apps/gdocs/templates/page-create-case",
  "jcr:language": "en",
  "cq:contextHubSegmentsPath": "/etc/segmentation/contexthub",
  "jcr:created": "Thu Feb 07 2019 06:30:52 GMT+0000",
  "cq:lastModified": "Wed Oct 25 2017 14:28:20 GMT+0000",
  "cq:cloudserviceconfigs": [
    "[]"
  ],
  "sling:resourceType": "gdocs/components/pages/create-case",
  "cq:contextHubPath": "/etc/cloudsettings/default/contexthub",
  "cq:lastModifiedBy": "admin",
  "par": {
    "jcr:primaryType": "nt:unstructured",
    "sling:resourceType": "wcm/foundation/components/parsys",
    "static_text_darkTitleBar": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "privacy": "Aviso de Privacidad",
      "label":"Se abre en una ventana nueva",
      "cookies": "Aviso de cookies",
      "termsCondition": "Términos y condiciones",
      "sling:resourceType": "gdocs/components/content/static_text"
    }
  }
}

export const FooterdataBA = {
  "jcr:primaryType": "cq:PageContent",
  "jcr:createdBy": "admin",
  "title": "footer-page",
  "cq:template": "/apps/gdocs/templates/page-create-case",
  "jcr:language": "en",
  "cq:contextHubSegmentsPath": "/etc/segmentation/contexthub",
  "jcr:created": "Thu Feb 07 2019 06:30:52 GMT+0000",
  "cq:lastModified": "Wed Oct 25 2017 14:28:20 GMT+0000",
  "cq:cloudserviceconfigs": [
    "[]"
  ],
  "sling:resourceType": "gdocs/components/pages/create-case",
  "cq:contextHubPath": "/etc/cloudsettings/default/contexthub",
  "cq:lastModifiedBy": "admin",
  "par": {
    "jcr:primaryType": "nt:unstructured",
    "sling:resourceType": "wcm/foundation/components/parsys",
    "static_text_darkTitleBar": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "privacy": "Pemberitahuan Privasi",
      "cookies": "Pemberitahuan Cookie",
      "label":"Terbuka di halaman baru",
      "termsCondition": "Syarat & Ketentuan",
      "sling:resourceType": "gdocs/components/content/static_text"
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layouts/Footer/json_footer-page.js